import * as React from 'react';
import RenderButton from './RenderButton';
import './ModulePage.scss';
import { FINISH_ERROR, FINISH_SUCCESS, LOAD, SAVE_ERROR, SAVE_ERROR_CDS, SAVE_IN_PROGRESS, SAVE_IN_PROGRESS_CDS, SAVE_SUCCESS, SAVE_SUCCESS_CDS } from '../../../constants/status';
const RenderNav = ({cat_id, org_rol_s, status, isLocked, 
                  onSubmit, unSubmit, lastModified, saveStatus, onPublish, enable}) => {

  const [displaySave, setDisplaySave] = React.useState();
  const [displayCDSSave, setDisplayCDSSave] = React.useState()

  React.useEffect(()=>{
                     
      if(saveStatus===LOAD){
        setDisplaySave(<span style={{color: 'white', padding:'10px 10px'}} data-testid='navDisplay' >{lastModified}</span>);
      }
      if(saveStatus===SAVE_IN_PROGRESS){
        setDisplaySave(<span style={{ display: 'flex', color: 'white', alignItems: 'center', justifyContent: 'space-between', paddingRight: '10px', flexWrap: 'nowrap', flexDirection: 'row', }}> <span style={{paddingRight: '10px'}} data-testid='navDisplay'>Save In Progress</span> <i className='cb-icon cb-refresh cb-white-color cb-icon-12' /> </span> );
      }
      if(saveStatus ===SAVE_SUCCESS){
        setDisplaySave(<span style={{ display: 'flex', color: 'white', alignItems: 'center', justifyContent: 'space-between', paddingRight: '10px', flexWrap: 'nowrap', flexDirection: 'row' }}> <span style={{paddingRight: '10px'}} data-testid='navDisplay'>Saved</span><i className='cb-icon cb-icon-circular cb-check cb-green1-color' /> </span>);
      }

      if(saveStatus ===SAVE_ERROR){
        setDisplaySave(<span style={{padding:'10px 10px'}} data-testid='navDisplay'>Failure<i className='cb-icon cb-icon-circular cb-error cb-red1-color' style={{float:'right', marginLeft:'10px'}}/></span>);
      }
      
      if(saveStatus===FINISH_SUCCESS){
        setDisplaySave(<span style={{ display: 'flex', color: 'white', alignItems: 'center', justifyContent: 'space-between', paddingRight: '10px', flexWrap: 'nowrap', flexDirection: 'row' }} data-testid='navDisplay'> <span style={{paddingRight: '10px'}}></span><i className='cb-icon cb-icon-circular cb-check cb-green1-color' /> </span> );
      }

      if(saveStatus===FINISH_ERROR){
        setDisplaySave(<span style={{padding:'10px 10px'}} data-testid='navDisplay'><i className='cb-icon cb-icon-circular cb-error cb-red1-color'/></span>);
      }
      
      //Save successful (+ banner)
      if (saveStatus === SAVE_SUCCESS_CDS) {
        setDisplayCDSSave( <span style={{ display: 'flex', color: 'white', alignItems: 'center', justifyContent: 'space-between', paddingRight: '10px', flexWrap: 'nowrap', flexDirection: 'row' }}> <span style={{paddingRight: '10px'}} data-testid='navDisplay'>Saved</span><i className='cb-icon cb-icon-circular cb-check cb-green1-color' /> </span> );
        setDisplaySave(<></>);
      }
      //Save in Progress
      if (saveStatus ===SAVE_IN_PROGRESS_CDS) {
        setDisplayCDSSave( <span style={{ display: 'flex', color: 'white', alignItems: 'center', justifyContent: 'space-between', paddingRight: '10px', flexWrap: 'nowrap', flexDirection: 'row', }}> <span style={{paddingRight: '10px'}} data-testid='navDisplay'>Save In Progress</span> <i className='cb-icon cb-refresh cb-white-color cb-icon-12' /> </span> );
      }
      //Save error (+ banner)
      if (saveStatus ===SAVE_ERROR_CDS) {
        setDisplayCDSSave( <span style={{ display: 'flex', color: 'white', alignItems: 'center', justifyContent: 'space-between', paddingRight: '10px', flexWrap: 'nowrap', flexDirection: 'row', }}> <span style={{paddingRight: '10px'}} data-testid='navDisplay'>Saving Error</span> <i className='cb-icon cb-icon-circular cb-error cb-red1-color' /> </span> );
        setDisplaySave(<></>);
  }
}, [lastModified, saveStatus]);
  

  return (
    <nav style={{width: '100%', justifyContent: 'flex-end'}} aria-label='Category Action' className='breadcrumb_format'>
      <span style={{display: 'flex', justifyContent: 'flex-end', width: '100%'}}>
        {displayCDSSave}
        {displaySave}
        <RenderButton cat_id={cat_id} roleNumber={org_rol_s} status={status} isLocked={isLocked} onSubmit={onSubmit} unSubmit={unSubmit} onPublish={onPublish} enable={enable&&saveStatus!=='saveInProgressCds'} />
      </span>
    </nav>
  );
};

export default RenderNav;